/** @format */

import React, {useContext} from 'react';
import PushableRequestButton from 'frontier/utilities/pushable_request_button';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';

export default function SingleShipmentJoinButton({
    fromShipmentId,
    toShipmentId,
    relatedShipmentIndex
}) {
    const ctx = useContext(CartCheckoutContext);
    return (
        <PushableRequestButton
            requestData={{fromShipmentId, toShipmentId}}
            onDone={({body: {shipments}}) => {
                ctx.onUpdateWithoutSave({shipments: {$set: shipments}});
            }}
            endpoint={`/account/shipments/combine/${toShipmentId}`}>
            <>
                This shipment could be combined with shipment {relatedShipmentIndex + 1}. To save
                money{' '}
                <b>
                    <u>combine shipments</u>
                </b>
                .
            </>
            <>Saving...</>
        </PushableRequestButton>
    );
}
